module.exports = __webpack_public_path__ + "img/cover-platform.129df8bb.jpg";